import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchBodegas, useUpdateBodegas } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { BODEGAS } from '@/shared/interfaces/erp/inventario';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrlBodegas = '/inventario/bodegas';

export interface BodegasPageInterface {}

const BodegasPage: React.FC<BodegasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_bodega);

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;
  ///* fetch data
  const {
    data: bodegasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchBodegas({
    page: pageIndex + 1,
    nombre: searchTerm,
  });
  ///* global state
const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
const setConfirmDialogIsOpen = useUiConfirmModalStore(
  s => s.setConfirmDialogIsOpen
);
  ///* mutations
  const updateBodegasMutation = useUpdateBodegas({navigate, returnUrl:returnUrlBodegas});
  ///* handlers
  const onEdit = (original: BODEGAS) => {
    navigate(`${returnUrlBodegas}/editar/${original.id_bodega}`);
  };
  ///* columns
  const columns = useMemo<MRT_ColumnDef<BODEGAS>[]>(
    () => [
     /*  {
        accessorKey: 'codigo',
        header: 'codigo',
        size: 200,
      }, */
      {
        accessorKey: 'numero_referencia',
        header: 'numero referencia',
        size: 200,
      },
      {
        accessorKey: 'nombre',
        header: 'nombre',
        size: 200,
      },
      {
        accessorKey: 'direccion',
        header: 'direcccion',
        size: 200,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado!}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={activo => {
              if (!hasPermission(PermissionsEnum.api_change_bodega)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateBodegasMutation.mutate({
                    id: row.original.id_bodega!,
                    data: {
                      ...row.original,
                      estado: activo as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: 'ciudad',
        header: 'ciudad',
        size: 200,
      },
    ],
    []
  );
  return (
    <SingleTableBoxScene title="Bodegas" urlRedirect={`${returnUrlBodegas}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_bodega)}>
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="Bodegas"
      />

      <GeneralTable<BODEGAS>
        columns={columns}
        data={bodegasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={bodegasPagingRes?.data?.count}
        // // actions
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_bodega,
        ])}
        actionsColumnSize={120}
        // crud
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_bodega,
        ])}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};
export default BodegasPage;
